export default __webpack_public_path__ + "static/media/qwiklabs4.38f4642c.png";